import globalStore from "/globalStore.js";
import config from "/config.js";
import { isAdminSectionVisible, canOpenAdministration } from "/navigation/admin-sections.js";
import { isModuleVisibleInNav } from "/navigation/module-release.js";
import { canViewPipeline, canOpenContacts, canOpenSalesReports } from "/module.crm/crm-access.js";

// The Sales & CRM report pages (navigation/routes.reports.js), so the CRM menu's Reports item stays selected on them.
const salesReportRouteNames = [
	"reports2-sales-pipeline-by-stage", "reports2-sales-pipeline-by-owner", "reports2-sales-forecast", "reports2-sales-target-attainment",
	"reports2-sales-win-loss", "reports2-sales-stalled-deals", "reports2-sales-cost-of-acquisition", "reports2-sales-activity",
];

const primaryNavigationSetup = {

	itemCount: 0,
	items: [],
	helpUrl: "",




	hasAccess(featureCode)
	{
		// Don't blow up. Might happen after updating data structures.
		if (!globalStore.currentUser) return false;

		// console.log("App.hasAccess(): featureCode=", featureCode);
		return globalStore.currentUser.hasFeatureAccess(featureCode)
	},





	initialiseMainMenu(params)
	{
		this.items = [];
		this.itemCount = 0;
		this.helpUrl = "";

		if (params.context == 'standard')
		{
			this.loadItemsForStandard(params);
		}
		if (params.context == 'mobile-app')
		{
			this.loadItemsForMobileApp(params);
		}

		// Find any child arrays with a null value in an index, and remove.
		this.stripNullChildren();

		this.setActiveMenuItem(params);

		return {
			itemCount: this.itemCount,
			items: this.items,
			helpUrl: this.helpUrl,

		};
	},




	initialiseAdminMenu(params)
	{
		this.items = [];
		this.itemCount = 0;
		this.helpUrl = "";

		this.loadItemsForAdmin(params);

		// Find any child arrays with a null value in an index, and remove.
		this.stripNullChildren();

		this.setActiveMenuItem(params);

		return {
			itemCount: this.itemCount,
			items: this.items,
			helpUrl: this.helpUrl,

		};
	},





	setActiveMenuItem(params)
	{
		const _this = this;
		const currentRouteName = params.currentRouteName;

		//console.log("currentRouteName=", currentRouteName);

		function checkItemsArray(array, debugLevel)
		{
			let containsActiveItem = false;

			// Nothing to do
			if (!array || array.length == 0) return;

			// Find and strip nulls item in the array.
			for (let i = 0; i < array.length; i++)
			{
				var item = array[i];
				var associatedRouteNames = item.associatedRouteNames;

				if (associatedRouteNames && associatedRouteNames.includes(currentRouteName))
				{
					item.isActive = true;
					containsActiveItem = true;
					_this.activeItem = item.id;
				}
				else
				{
					// Ensure all other items are disabled as active.
					item.isActive = false;
				}
			}

			// Go down the tree of children. Do it in a new loop after any nulls are stripped from the array.
			for (let i = 0; i < array.length; i++)
			{
				const children = array[i].children;

				if (children && children.length > 0)
				{
					//console.log(spaces(debugLevel * 2) + " - call children...", children);
					const childrenContainsActiveItem = checkItemsArray(children, debugLevel + 1);
					if (childrenContainsActiveItem)
					{
						// One of the children is the active item, so we want to ensure the group it's in is expanded.
						array[i].isActiveGroup = true;
					}
					else
					{
						// Ensure all other groups are not set as having an active item.
						array[i].isActiveGroup = false;
					}
				}
			}

			return containsActiveItem;
		}


		checkItemsArray(this.items, 1);
	},

	



	/**
	 * Load the menu items for pages embedded within the mobile app.
	 */
	loadItemsForMobileApp(params)
	{
		//-- Manage: Jobs, Tasks and Scheduling
		if (this.hasAccess('AccountAdmin.All'))
		{
			this.getItemFaIcon("New Job", "fas fa-plus", "/mobile-app/new-job", []);

			this.getItemFaIcon("Manage Jobs", "fas fa-tasks", "/mobile-app/manage-jobs", [], null, null);
		}

	},

	



	/**
	 * Load the menu items for pages viewed within the standard portal in a browser.
	 */
	loadItemsForStandard(params)
	{
		var _this = this;



		//----- HOME -----
		//TDOO: Disable until we have an actual page.
		function homeItems()
		{
			// All users can access this page
			_this.getItemFaIcon("Home", "fas fa-home", "/home", [], null, null);
		}
		//homeItems();

		

		//---- Clinets/Customers -----
		function clients()
		{
			if (!_this.hasAccess('AccountAdmin.All'))
			{
				return;
			}
			const accountId = globalStore.state.currentUser.activeAccountId;

			_this.addModuleRootItemFaIcon('clients', "Clients", "far fa-file-alt", "/manage/" + accountId + "/clients-buckets-tasks",
				null,
				null,
				["manage-clients-buckets-tasks"]
			);
		}
		clients();





		//---- Timesheets module -----
		function timesheetsModule()
		{
			console.log("globalStore.state.currentUser.completeAccessStructure=", globalStore.state.currentUser.completeAccessStructure);

			// The module must be on for the account. Using Timesheets (the Home page, the keyword and admin
			// pages) additionally needs `Timesheets.Core`; approving does not (decided 2026-10-03: holding
			// `Timesheets.ApproveTeamEntries` is what gives the Approvals item, so an approver on an account or
			// seat without Core still gets the group, holding only Approvals).
			const timesheetsEnabled = _this.hasAccess('Timesheets.Enabled');
			const canUseTimesheets = timesheetsEnabled && _this.hasAccess('Timesheets.Core');
			const canApprove = _this.hasAccess('Timesheets.ApproveTeamEntries') || _this.hasAccess('AccountAdmin.All') || params.isSystemAdminUser;

			if (!timesheetsEnabled || !(canUseTimesheets || canApprove))
			{
				console.log("timesheetsModule(): NO ACCESS :(");
				return;
			}

			console.log("timesheetsModule(): ACCESS!!!");


			//NOTE: "(👁)" denotes under development/dev only at the moment.

			var accountId = globalStore.state.currentUser.activeAccountId;

			var children = [];

			if (canUseTimesheets)
			{
				const homeItem = _this.getItemFaIcon("Home", "far fa-file-alt", "/home/timesheets", [], null, ["home-timesheets-view", "view-timesheet", "edit-timesheet", "edit-timesheet1"]);
				homeItem.badgeKey = "myOutstanding";	// The user's own Draft + Rejected days in the Approvals window (see approvals-store.js).
				children.push(homeItem);
			}

			// The Approvals workspace. Offered to anyone who could be an approver; the layout then hides it
			// unless the Approvals availability read says approval is switched on and the user is one
			// (`visibleWhen`), and shows the pending count (`badgeKey`). `matchByRouteNames` lets the item
			// stay highlighted on its sub-routes (bulk, outstanding, day), which an exact path match wouldn't.
			if (canApprove)
			{
				const approvalsItem = _this.getItemFaIcon(
					"Approvals",
					"far fa-circle-check",
					"/module/timesheets/approvals",
					[],
					null,
					["timesheets-approvals", "timesheets-approvals-bulk", "timesheets-approvals-outstanding", "timesheets-approvals-day"]
				);
				approvalsItem.badgeKey = "approvalsPending";
				approvalsItem.visibleWhen = "approvalsAvailable";
				approvalsItem.matchByRouteNames = true;
				children.push(approvalsItem);
			}

			//TODO: Currently under development
			let newKeywordsItem = null;
			if (canUseTimesheets && _this.hasAccess('LotusDevelopment.All'))
			{
				// Still in development
				newKeywordsItem = _this.getItemFaIcon("Extract Keywords (👁)", "far fa-file-alt", "/module/timesheets/keywords/new-detected", [], null, ["timesheets-new-detected-keywords"]);
				children.push(newKeywordsItem);
			}

			//TODO: Update this when ready for production.
			// 	if (_this.hasAccess('Timesheet.Manager'))
			// 	{

			// 		children.push(_this.getItemX("Outstanding Timesheets", "far fa-file-alt", "/module/timesheets/manager/outstanding-timesheets", [], ["timesheets-manager-outstanding"]));
			// 		children.push(_this.getItemX("Timesheet Report", "far fa-file-alt", "/module/timesheets/manager/timesheets-report", [], ["timesheets-manager-report"]));
			// 	}



			if (canUseTimesheets && _this.hasAccess('LotusDevelopment.All'))
			{
				const adminItem = _this.getItemFaIcon(
					"Admin (👁)",
					"fas fa-hammer",
					"/module/timesheets/admin",
					[],
					null, 
					["timesheets-admin-index"]
				);

				children.push(adminItem);
			}


			// The collapsed group shows the Approvals count, so pending days can't be missed behind it.
			const timesheetsGroup = _this.addModuleRootItemFaIcon('timesheets', 'Timesheets', 'far fa-clock', '', children);
			timesheetsGroup.badgeKey = "approvalsPending";
		}
		timesheetsModule();













		//----- Module: Rostering -----
		function rosteringModule()
		{
			if (!(_this.hasAccess('Rostering.RosteringAdministrator') || _this.hasAccess('Rostering.DashboardLogin') || _this.hasAccess('Rostering.DashboardAdmin')))
			{
				return;
			}

			let children = [];

			//-- Admin
			var jobsAdminItem = _this.getItemFaIcon("Jobs Admin", "fas fa-tasks", "/module/rostering/admin", [], null, ["rostering-admin-page", "rostering-admin-new-job", "rostering-admin-edit-job"]);
			var payrollReportItem = _this.getItemFaIcon("Payroll Report", "fas fa-table", "/module/rostering/admin/reports/payroll", [], null, ["rostering-admin-reports-payroll"]);

			if (_this.hasAccess('Rostering.RosteringAdministrator'))
			{
				children.push(jobsAdminItem);
				children.push(payrollReportItem);
			}


			//-- Kiosk/Dashboard
			let kioskItem = _this.getItemFaIcon("Kiosk", "fas fa-sign-in-alt", "/module/rostering/kiosk", [], null, ["rostering-kiosk-index"]);
			if (_this.hasAccess('Rostering.DashboardLogin') || _this.hasAccess('Rostering.DashboardAdmin')) 
			{
				children.push(kioskItem);
			}


			//-- Admin
			let adminItem = _this.getItemFaIcon(
				"Admin (👁)",
				"fas fa-hammer",
				"/module/rostering/settings",
				[],
				null, 
				["rostering-settings-index"]
			);
			if (_this.hasAccess('LotusDevelopment.All'))
			{
				children.push(adminItem);
			}

			_this.addModuleRootItemFaIcon('rostering', 'Rostering', 'far fa-file-alt', '', children);
		}
		rosteringModule();




		//----- Module: Valen HR -----
		function valenHrModule()
		{
			//TODO: Disabled until the features are implemented
			if (
				!_this.hasAccess("ValenHR.Enabled") &&
				!_this.hasAccess("ValenHR.Core")
			)
			{
				return;
			}


			let subItems = [];

			const isReviewingManager = _this.hasAccess("ValenHR.ReviewingManager");
			const isReviewingManagerTopLevel = _this.hasAccess("ValenHR.ReviewingManager.TopLevel");

			subItems.push((isReviewingManager || isReviewingManagerTopLevel) ? _this.getItemFaIcon(
				"Manager Dashboard",
				"fas fa-sitemap",
				"/module/" + config.modules.valenHr.routePath + "/manager/dashboard",
				[],
				null, 
				[
					"valen-hr-manager-index", "valen-hr-manager-performance-reviews",
					"valen-hr-user-profile-index", "valen-hr-user-profile"
				]
			) : null);


			subItems.push(_this.getItemFaIcon(
				"My Dashboard",		//"Employee Dashboard",
				"fas fa-thumbtack",
				"/module/" + config.modules.valenHr.routePath + "/employee",
				[],
				null, 
				["valen-hr-employee-index"]
			));
			subItems.push((isReviewingManager || isReviewingManagerTopLevel) ? _this.getItemFaIcon(
				"Employee Review",
				"fas fa-clipboard-list",
				"/module/" + config.modules.valenHr.routePath + "/review",
				[],
				null, 
				["valen-hr-review-index", "valen-hr-review-new", "valen-hr-review-edit"]
			) : null);

			//TODO: Disable for test environment until development complete
			subItems.push(_this.getItemFaIcon(
				"Kudos",
				"fas fa-hammer",
				"/module/" + config.modules.valenHr.routePath + "/kudos/dashboard",
				[],
				null, 
				["valen-hr-kudos-index", "valen-hr-kudos-user"]
			));

			// Staff HR administration is its own permission - account administration doesn't include it.
			const canAccessAdminSection = _this.hasAccess("ValenHR.AdminSectionAll");
			subItems.push(canAccessAdminSection ? _this.getItemFaIcon(
				"Admin",
				"fas fa-hammer",
				"/module/" + config.modules.valenHr.routePath + "/admin",
				[],
				null, 
				["valen-hr-admin-index"]
			) : null);


			_this.addModuleRootItemFaIcon(
				"valen-hr",
				config.modules.valenHr.displayName,
				"fas fa-people-arrows",
				"",
				subItems
			);
		}
		valenHrModule();




		//---- Sales & CRM ----
		function salesCrmModule()
		{
			// The account's licence and module switch, then each item by the person's own CRM features (as the API checks them).
			const items = [
				...(canViewPipeline()
					? [
						_this.getItemFaIcon("Home", "fa-solid fa-circle", "/module.crm", [], null, ["crm-home"]),
						_this.getItemFaIcon("Pipeline", "fa-solid fa-circle", "/module.crm/pipeline", [], null, ["crm-pipeline", "crm-pipeline-detail"]),
					]
					: []),
				...(canOpenContacts()
					? [_this.getItemFaIcon("Contacts", "fa-solid fa-circle", "/module.crm/contacts", [], null, ["crm-contacts"])]
					: []),
				...(canOpenSalesReports()
					? [_this.getItemFaIcon("Reports", "fa-solid fa-circle", "/module.crm/reports", [], null, ["crm-reports", ...salesReportRouteNames])]
					: []),
			];

			if (items.length == 0) return;

			_this.addModuleRootItemFaIcon(
				"crm",
				"Sales & CRM",
				"fa-solid fa-gears",
				"",
				items
			);
		}
		salesCrmModule();




		//---- Projects module ----
		function projectsModule()
		{
			if (!isModuleVisibleInNav("projects")) return;
			if (!_this.hasAccess("Projects.Enabled")) return;

			_this.addModuleRootItemFaIcon('projects', "Projects", "fa-solid fa-diagram-project", "/module.projects",
				null,
				null,
				["module.projects-index", "module.projects-setup", "module.projects-detail"]
			);
		}
		projectsModule();




			//---- Resource Planning module ----
			function resourcePlanningModule()
			{
				if (!isModuleVisibleInNav("resourcing")) return;
				if (!_this.hasAccess("Resourcing.Enabled")) return;

				_this.addModuleRootItemFaIcon('resourcing', "Resource Planning", "fa-solid fa-calendar-days", "",
					[
						_this.getItemFaIcon("Capacity & Schedule", "fa-solid fa-circle", "/module.resource-planning", [], null, ["module.resource-planning-index"]),
						_this.getItemFaIcon("Open Buckets", "fa-solid fa-circle", "/module.resource-planning/open-buckets", [], null, ["module.resource-planning-open-buckets"]),
						_this.getItemFaIcon("Conflicts", "fa-solid fa-circle", "/module.resource-planning/conflicts", [], null, ["module.resource-planning-conflicts"]),
						_this.getItemFaIcon("Import baseline", "fa-solid fa-circle", "/module.resource-planning/import", [], null, ["module.resource-planning-import"]),
					]
				);
			}
			resourcePlanningModule();


			//---- My Plan (everyone, independent of planning permission) ----
			function myPlanModule()
			{
				if (!isModuleVisibleInNav("resourcing")) return;		// My Plan is part of the Resource Planning module.
				if (!_this.hasAccess("Resourcing.ViewOwnPlan")) return;

				_this.addModuleRootItemFaIcon('my-plan', "My Plan", "fa-solid fa-circle-check", "/my-plan", null, null, ["resource-planning-my-plan"]);
			}
			myPlanModule();















		//---- Reports for all modules -----
		// The old reports screen, Lotus staff only (the new reports module is seat-controlled).
		function reports()
		{
			if (_this.hasAccess('AccountAdmin.All') && (_this.hasAccess('LotusAdministration.All') || _this.hasAccess('LotusDevelopment.All')))
			{
				const reportsMain = ["reports-home", "report-by-id", "structured-report-by-id", "database-report-by-id"]
				const bucketsReport = ["timesheet-buckets-report", "timesheet-buckets-report-entry", "timesheet-buckets-report-account", "timesheet-buckets-report-bucket-summary", "timesheet-buckets-report-bucket-detail", "timesheet-buckets-report-bucket-breakdown"];
				const timesheetSummary = ["timesheet-summary-report"];
				const routesList = [...reportsMain, ...bucketsReport, ...timesheetSummary];


				_this.addModuleRootItemFaIcon('reports', "Reports (Old)", "fas fa-table", "/reports/",
					null,
					null,
					routesList
				);
			}
		}
		reports();




		function reports2()
		{
			if (_this.hasAccess('Reporting.ViewWithinPermissions'))
			{
				const reportsMain = ["reports-home", "report-by-id", "structured-report-by-id", "database-report-by-id"]
				const bucketsReport = ["timesheet-buckets-report", "timesheet-buckets-report-entry", "timesheet-buckets-report-account", "timesheet-buckets-report-bucket-summary", "timesheet-buckets-report-bucket-detail", "timesheet-buckets-report-bucket-breakdown"];
				const timesheetSummary = ["timesheet-summary-report"];
				// The new reports pages (navigation/routes.reports.js), so the menu item stays selected on them.
				const reports2Pages = [
					"reports2-index", "reports2-time-report", "reports2-client-time-breakdown", "reports2-customer-portal-preview",
					"reports2-bucket-spend", "reports2-margin-by-role", "reports2-unsubmitted-time", "reports2-approval-status",
					"reports2-needs-allocation", "reports2-my-time",
				];
				const routesList = [...reportsMain, ...bucketsReport, ...timesheetSummary, ...reports2Pages];


				_this.addModuleRootItemFaIcon('reports', "Reports", "fas fa-table", "/reports2/",
					null,
					null,
					routesList
				);
			}
		}
		reports2();



















		//---- My Profile -----
		function myProfile()
		{
			//TODO: While testing.
			//if( !(_this.hasAccess('LotusAdministration.All') || _this.hasAccess('LotusDevelopment.All')) )
			if (!(_this.hasAccess('LotusDevelopment.All')))
			{
				return;
			}

			if (_this.hasAccess('AccountAdmin.All'))
			{
				_this.addModuleRootItemFaIcon('account', "My Profile", "far fa-user", "/my-profile",
					null,
					null,
					["my-profile"]
				);
			}
		}
		//TODO: Obsolete
		//myProfile();






		//---- Logged in Account Admin (original - just for Lotus moving forard) -----
		function accountAdmin()
		{
			if (!_this.hasAccess('AccountAdmin.All'))
			{
				return;

			}
			_this.addModuleRootItemDivider('divider-above-administration-link');


			const accountId = globalStore.state.currentUser.activeAccountId;

			_this.addModuleRootItemFaIcon('account', "Account & People", "far fa-address-card", "/account-admin/" + accountId,
				null,
				null,
				["account-admin-root", "account-admin-home"]
			);
			
		}
		//TODO: Obsolete
		//accountAdmin();


		//---- Admnistration menu -----
		function administration()
		{
			console.log("administration------", _this.hasAccess('LotusDevelopment.All') );
			
			// Account admins, and anyone who administers one section of it (such as the CRM's own administrators).
			if (!canOpenAdministration())
			{
				return;
			}

			//TODO: Additional guard while testing.
			// if( !(_this.hasAccess('LotusAdministration.All') || _this.hasAccess('LotusDevelopment.All') || config.IsDevelopment()) )
			// {
			// 	return;
			// }

			_this.addModuleRootItemDivider('divider-above-administration-link');

			//accountAdmin();

			_this.addModuleRootItemFaIcon('admin', "Administration", "fa-solid fa-gears", "/admin",
				null,
				null,
				["admin-index"]
			);
		}
		administration();









		//---- Logged in Account Admin -----
		function dividerBeforeLotusAtBottom()
		{
			if (!(_this.hasAccess('LotusAdministration.All') || _this.hasAccess('LotusDevelopment.All')))
			{
				return;
			}

			_this.addModuleRootItemDivider('divider-above-lotus-section');
		}
		dividerBeforeLotusAtBottom();


		//----- Lotus Admin / System Admin -----
		function lotusSystemAdmin()
		{
			if (!(_this.hasAccess('LotusAdministration.All') || _this.hasAccess('LotusDevelopment.All')))
			{
				return;
			}


			// let homeItem = null;
			// if (params.isSystemAdminUser)
			// {
			// 	homeItem = _this.getItemFaIcon("Home", "fas fa-home", "/home/LotusOnly", [], null, ["home-lotus-only-view"]);
			// }

			_this.addModuleRootItemFaIcon('lotus', "Lotus Staff", "fas fa-toolbox", "",
				[
					//homeItem,
					_this.getItemFaIcon("Accounts", "fas fa-user", "/system-admin/accounts", [], null, 
						["system-admin-accounts",
							"system-admin-accounts-edit",
							"account-admin-settings",
							"account-admin-users",
							"account-admin-user-edit",
							"account-admin-user-access",
							"account-admin-user-new"]
					),


					_this.getItemFaIcon("Review Timesheets", "far fa-clock", "/system-admin/review-timesheets", [], null, ["SystemAdminReviewTimesheets"]),

					_this.getItemFaIcon("Seats & Inclusions", "fas fa-layer-group", "/system-admin/seat-inclusions", [], null, ["system-admin-seat-inclusions"]),

					_this.getItemFaIcon("System Messages", "fas fa-bullhorn", "/system-admin/system-messages", [], null,
						["system-admin-system-messages",
							"system-admin-system-messages-new",
							"system-admin-system-messages-edit"]
					),
				],
			);
		}
		lotusSystemAdmin();








		function developerGuideInDevAndTest()
		{
			if (!_this.hasAccess('LotusDevelopment.All'))
			{
				// Only run this is dev and test environments.
				return;
			}

			_this.addModuleRootItemFaIcon('developers', "Lotus Developers (👁)", "fas fa-toolbox", "",
				[
					_this.getItemFaIcon("Developer Guide", "fas fa-border-style", "/developers/dev-guide", [], null, 
						["dev-guide-home", "dev-guide-layout", "dev-guide-typography", "dev-guide-buttons", "dev-guide-forms",
							"dev-guide-graphics", "dev-guide-tables",
							"dev-guide-other",
							"dev-guide-test-calendar", "dev-guide-test-calendar-with-timesheet",
							"dev-guide-test-keyword-extraction",]
					),
					_this.getItemFaIcon("Showcase", "fas fa-key", "/developers/showcase", [], null, ["dev-showcase"]),
					_this.getItemFaIcon("Code Snippets", "fas fa-code", "/developers/snippets", [], null, ["dev-snippets-index", "dev-snippets-topic"]),
					_this.getItemFaIcon("Configuration", "fas fa-sliders", "/developers/configuration", [], null, ["dev-configuration"]),
					_this.getItemFaIcon("Files", "fas fa-folder-open", "/developers/files", [], null, ["developers-files"]),
					_this.getItemFaIcon("Background tasks", "fas fa-key", "/background-tasks", [], null, ["background-tasks"]),		// Prototype until ready for all users (maybe)
					//_this.getItemFaIcon("Timesheet Dashboard", "fas fa-key", "/developers/developer-timesheet-dashboard", []),	//TODO: I think this is a placeholder for a page I didn't create yet.
					_this.getItemFaIcon("My Current Activity", "fas fa-key", "/developers/current-activity?context=developer-review", [], null, ["developers-current-timesheet-activity"]),

					_this.getItemFaIcon("API Info", "fas fa-code-branch", "/developers/api-info", [], null, ["developers-api-info"]),

					_this.getItemFaIcon("Debug Logs", "fas fa-key", "/debugger/debug-logs", [], null, [""]),
					_this.getItemFaIcon("Monitoring Logs", "fas fa-key", "/monitoring/logs", [], null, [""]),
					_this.getItemFaIcon("Email Send Logs", "fas fa-envelope", "/developers/email-send-logs", [], null, ["developers-email-send-logs"]),
				],
			);
		}
		developerGuideInDevAndTest();







		_this.helpUrl = "/kb/with-path/?path=" + params.currentRoute.matched[0].path;
	},









	/**
	 * Load the menu items for pages embedded within the mobile app.
	 */
	loadItemsForAdmin(params)
	{
		const _this = this;

		//-- People
		if (isAdminSectionVisible('people'))
		{
			_this.addModuleRootItemFaIcon('people', "People", "fa-solid fa-user-group", "/admin/people",
				[
					_this.getItemFaIcon("Staff", "fa-solid fa-circle", "/admin/people/staff", [], null, ["admin-people-staff", "admin-people-staff-new", "admin-people-staff-edit"]),
					_this.getItemFaIcon("Roles", "fa-solid fa-circle", "/admin/people/roles", [], null, ["admin-people-roles"]),
					_this.getItemFaIcon("Teams", "fa-solid fa-circle", "/admin/people/teams", [], null, ["admin-people-teams", "admin-people-teams-new", "admin-people-teams-detail"]),
					_this.getItemFaIcon("Seats & inclusions", "fa-solid fa-circle", "/admin/people/seats-inclusions", [], null, ["admin-people-seats-inclusions"]),
					_this.getItemFaIcon("Pending Invites", "fa-solid fa-circle", "/admin/people/pending-invites", [], null, ["admin-people-pending-invites"]),
				],
				null,
				["admin-people-index"],
			);
		}

		//-- Clients & Buckets
		if (isAdminSectionVisible('clientsAndBuckets'))
		{
			let taskTempaltes = null;
			if (isAdminSectionVisible('clientsAndBucketsTaskTemplates'))
			{
				taskTempaltes = _this.getItemFaIcon("Task Templates", "fa-solid fa-circle", "/admin/clients-and-buckets/task-templates", [], null, ["admin-clients-and-buckets-task-templates", "admin-clients-and-buckets-task-templates-new", "admin-clients-and-buckets-task-templates-detail"]);
			}
			
			_this.addModuleRootItemFaIcon('clients-and-buckets', "Clients & Buckets", "fa-regular fa-folder-closed", "/admin/clients-and-buckets",
				[
					_this.getItemFaIcon("Clients", "fa-solid fa-circle", "/admin/clients-and-buckets/clients", [], null, ["admin-clients-and-buckets-clients", "admin-clients-and-buckets-clients-new", "admin-clients-and-buckets-clients-detail"]),
					_this.getItemFaIcon("Buckets", "fa-solid fa-circle", "/admin/clients-and-buckets/buckets", [], null, ["admin-clients-and-buckets-buckets", "admin-clients-and-buckets-buckets-new", "admin-clients-and-buckets-buckets-detail"]),
					taskTempaltes
				],
				null,
				["admin-clients-and-buckets-index"],
			);
		}

		//-- CRM & Sales
		if (isAdminSectionVisible('crmAndSales'))
		{
			_this.addModuleRootItemFaIcon('crm-and-sales', "CRM & Sales", "fa-solid fa-handshake", "/admin/crm-and-sales",
				[
					_this.getItemFaIcon("Pipeline stages", "fa-solid fa-circle", "/admin/crm-and-sales/pipeline-stages", [], null, ["admin-crm-and-sales-pipeline-stages"]),
					_this.getItemFaIcon("Contact types", "fa-solid fa-circle", "/admin/crm-and-sales/contact-types", [], null, ["admin-crm-and-sales-contact-types"]),
					_this.getItemFaIcon("Deal sources", "fa-solid fa-circle", "/admin/crm-and-sales/deal-sources", [], null, ["admin-crm-and-sales-deal-sources"]),
					_this.getItemFaIcon("Loss categories", "fa-solid fa-circle", "/admin/crm-and-sales/loss-categories", [], null, ["admin-crm-and-sales-loss-categories"]),
					_this.getItemFaIcon("Product catalogue", "fa-solid fa-circle", "/admin/crm-and-sales/product-catalogue", [], null, ["admin-crm-and-sales-product-catalogue", "admin-crm-and-sales-product-catalogue-new", "admin-crm-and-sales-product-catalogue-detail"]),
					_this.getItemFaIcon("Pipeline visibility", "fa-solid fa-circle", "/admin/crm-and-sales/pipeline-visibility", [], null, ["admin-crm-and-sales-pipeline-visibility"]),
					_this.getItemFaIcon("Sales targets", "fa-solid fa-circle", "/admin/crm-and-sales/sales-targets", [], null, ["admin-crm-and-sales-sales-targets"]),
				],
				null,
				["admin-crm-and-sales-index"],
			);
		}

		//-- Mobile
		if (isAdminSectionVisible('mobile'))
		{
			_this.addModuleRootItemFaIcon('mobile', "Mobile", "fa-solid fa-mobile-screen", "/admin/mobile",
				[
					_this.getItemFaIcon("Licensed users", "fa-solid fa-circle", "/admin/mobile/licensed-users", [], null, ["admin-mobile-licensed-users"]),
					_this.getItemFaIcon("Geofencing sites", "fa-solid fa-circle", "/admin/mobile/geofencing-sites", [], null, ["admin-mobile-geofencing-sites"]),
				],
				null,
				["admin-mobile-index"],
			);
		}

		//-- Rostering
		if (isAdminSectionVisible('rostering'))
		{
			_this.addModuleRootItemFaIcon('rostering', "Rostering", "fa-solid fa-calendar-days", "",
				[
					_this.getItemFaIcon("Settings", "fa-solid fa-circle", "/admin/rostering/settings", [], null, ["admin-rostering-settings"]),
					_this.getItemFaIcon("Kiosk & Locations", "fa-solid fa-circle", "/admin/rostering/kiosk-and-locations", [], null, ["admin-rostering-kiosk-and-locations"]),
				],
			);
		}

		//-- Financials
		if (isAdminSectionVisible('financials'))
		{
			_this.addModuleRootItemFaIcon('financials', "Financials", "fa-solid fa-dollar-sign", "/admin/financials",
				[
					_this.getItemFaIcon("Rates", "fa-solid fa-circle", "/admin/financials/rates", [], null, ["admin-financials-rates"]),
					_this.getItemFaIcon("Currency & FX", "fa-solid fa-circle", "/admin/financials/currency-fx", [], null, ["admin-financials-currency-fx"]),
					_this.getItemFaIcon("Billable targets", "fa-solid fa-circle", "/admin/financials/billable-targets", [], null, ["admin-financials-billable-targets"]),
					_this.getItemFaIcon("Rounding", "fa-solid fa-circle", "/admin/financials/rounding", [], null, ["admin-financials-rounding"]),
					_this.getItemFaIcon("Period locking", "fa-solid fa-circle", "/admin/financials/period-locking", [], null, ["admin-financials-period-locking"]),
					_this.getItemFaIcon("Cost rates", "fa-solid fa-circle", "/admin/financials/cost-rates", [], null, ["admin-financials-cost-rates"]),
				],
				null,
				["admin-financials-index"],
			);
		}

		//-- Reporting (whose time each person can report on)
		if (isAdminSectionVisible('reporting'))
		{
			_this.addModuleRootItemFaIcon('reporting-access', "Reporting", "fa-solid fa-chart-column", "/admin/reporting/access",
				null,
				null,
				["admin-reporting-access"],
			);
		}

		//-- Agent & Devices
		if (isAdminSectionVisible('devices'))
		{
			_this.addModuleRootItemFaIcon('devices', "Agent & Devices", "fa-solid fa-computer", "",
				[
					_this.getItemFaIcon("By user", "fa-solid fa-circle", "/admin/devices/by-user", [], null, ["admin-devices-by-user"]),
					_this.getItemFaIcon("All devices", "fa-solid fa-circle", "/admin/devices/all-devices", [], null, ["admin-devices-all-devices"]),
					_this.getItemFaIcon("Fleet view", "fa-solid fa-circle", "/admin/devices/fleet-view", [], null, ["admin-devices-fleet-view"]),
				],
			);
		}

		//-- AI
		if (isAdminSectionVisible('ai'))
		{
			_this.addModuleRootItemFaIcon('ai', "AI", "fa-solid fa-microchip", "",
				[
					_this.getItemFaIcon("Capabilities", "fa-solid fa-circle", "/admin/ai/capabilities", [], null, ["admin-ai-capabilities"]),
					_this.getItemFaIcon("Infrastructure", "fa-solid fa-circle", "/admin/ai/infrastructure", [], null, ["admin-ai-infrastructure"]),
				],
			);
		}

		//-- Integrations
		if (isAdminSectionVisible('integrations'))
		{
			_this.addModuleRootItemFaIcon('integrations', "Integrations", "fa-solid fa-plug", "", null);
		}

		//-- Organisation Settings
		if (isAdminSectionVisible('orgSettings'))
		{
			_this.addModuleRootItemFaIcon('org-settings', "Organisation Settings", "fa-solid fa-sliders", "/admin/org-settings",
				[
					_this.getItemFaIcon("Org & locations", "fa-solid fa-circle", "/admin/org-settings/org-locations", [], null, ["admin-org-settings-org-locations"]),
					_this.getItemFaIcon("Approvals", "fa-solid fa-circle", "/admin/org-settings/approvals", [], null, ["admin-org-settings-approvals"]),
					_this.getItemFaIcon("Terminology", "fa-solid fa-circle", "/admin/org-settings/terminology", [], null, ["admin-org-settings-terminology"]),
					_this.getItemFaIcon("General & security", "fa-solid fa-circle", "/admin/org-settings/general-security", [], null, ["admin-org-settings-general-security"]),
					_this.getItemFaIcon("Project presets", "fa-solid fa-circle", "/admin/projects/presets", [], null, ["admin-projects-presets"]),
				],
				null,
				["admin-org-settings-index"],
			);
		}

		//-- Audit Log
		if (isAdminSectionVisible('auditLog'))
		{
			_this.addModuleRootItemFaIcon('audit-log', "Audit Log", "fa-solid fa-clock", "", null);
		}


		// _this.addModuleRootItemFaIcon('xxx', "Xxxx", "fa-solid fa-xxxx", "",
		// 	[
		// 		_this.getItemFaIcon("Xxxx", "fa-solid fa-cirlce", "/admin/xxx/xxx", [], null, ["admin-xxx-xxx"]),
		// 		_this.getItemFaIcon("Xxxx", "fa-solid fa-cirlce", "/admin/xxx/xxx", [], null, ["admin-xxx-xxx"]),
		// 		_this.getItemFaIcon("Xxxx", "fa-solid fa-cirlce", "/admin/xxx/xxx", [], null, ["admin-xxx-xxx"]),
		// 		_this.getItemFaIcon("Xxxx", "fa-solid fa-cirlce", "/admin/xxx/xxx", [], null, ["admin-xxx-xxx"]),
		// 	],
		// );

	},

	








	addModuleRootItemFaIcon(module, text, faIcon, url, children, func, associatedRouteNames)
	{
		const item = this.getItemFaIcon(text, faIcon, url, children, func, associatedRouteNames ? associatedRouteNames : []);

		item.module = module;

		this.items.push(item);

		return item;
	},



	addModuleRootItemDivider(id)
	{
		const item = {
			id: id,
			text: "",
			faIcon: "",
			url: "",
			children: [],
			func: null,
			associatedRouteNames: [],
			type: "divider"
		};

		item.module = "";

		this.items.push(item);

		return item;
	},



	getItemFaIcon(text, faIcon, url, children, func, associatedRouteNames)
	{
		this.itemCount++;

		const item = {
			id: this.itemCount,
			text: text,
			faIcon: faIcon,
			url: url,
			children: children,
			func: func,
			associatedRouteNames: associatedRouteNames,
			type: "item"
		};

		return item;
	},

	



	/**
	 * Find any child arrays in `items` with a null value in an index, and remove.
	 */
	stripNullChildren()
	{
		function checkAndStripArray(array, debugLevel)
		{
			// Nothing to do
			if (!array || array.length == 0) return;

			// Find and stripp nulls item in the array.
			for (let i = 0; i < array.length; i++)
			{
				//console.log(spaces(debugLevel * 2) + "stripping...", array[i]);
				if (array[i] == null)
				{
					array.splice(i, 1);
				}
			}

			// Go down the tree of children. Do it in a new loop after any nulls are stripped from the array.
			for (let i = 0; i < array.length; i++)
			{
				const children = array[i].children;

				if (children && children.length > 0)
				{
					//console.log(spaces(debugLevel * 2) + " - call childre...", children);
					checkAndStripArray(children, debugLevel + 1);
				}
			}
		}


		checkAndStripArray(this.items, 1);
	},




};

export default primaryNavigationSetup;